export default __webpack_public_path__ + "static/media/database_example.4532ddfd.csv";